import { useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { Button } from 'js/components/common/Button';
import { DateTimePickerPopup } from '../DateTimePickerPopup';
import { addPopupAction } from 'js/components/common/PopupManager';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../../store';
import { useExecuteAction } from '../../hooks/useExecuteAction';

export const AddNewScheduledBreak = () => {
    const dispatch = useDispatch();
    const translate = useComponentTranslations();
    const { isLoading, isActionsDisabled } = useDynamicReducerSelector(pick([
        'isLoading', 'isActionsDisabled'
    ]));
    const addNewScheduledBreak = useExecuteAction({ type: 'add' });
    const onClick = useCallback(() => {
        dispatch(addPopupAction({
            component: DateTimePickerPopup,
            onSave: addNewScheduledBreak
        }));
    }, [dispatch, addNewScheduledBreak]);

    return (
        <Button
            type="button"
            view="primary"
            onClick={onClick}
            disabled={isLoading || isActionsDisabled}
        >
            {translate('add')}
        </Button>
    );
};
